import { gql } from '@apollo/client'
import employeeWithBuFragment from '../employee/fragments/employeeWithBu.fragment'

export const INVITE_OPTIONS = gql`
  query InviteOptions($employeeId: HashedId!, $appraisalSeasonId: HashedId) {
    meetingInviteOptionsForEmployee(employeeId: $employeeId, appraisalSeasonId: $appraisalSeasonId) {
      possible
      tagAssignmentIsInProgress
      isAppraisalEnabled
    }
  }
`

export const NON_PARTICIPANTS_OPTIONS = gql`
  query NonParticipantsOptions($employeeId: HashedId!) {
    nonParticipantsOptionsForEmployee(employeeId: $employeeId) {
      ...EmployeeWithBu
    }
  }
  ${employeeWithBuFragment}
`

export const APPRAISAL_SEASON_OPTION = gql`
  query AppraisalSeasonOptionByEmployeeId($employeeId: HashedId!, $utcMeetingDate: String!) {
    appraisalSeasonOptionByEmployeeId(employeeId: $employeeId, utcMeetingDate: $utcMeetingDate) {
      id
      companyId
      country
      year
      fromDate
      toDate
    }
  }
`

export const EMPLOYEE_WITH_APPRAISAL_INVITE_INFO = gql`
  query EmployeeWithAppraisalInviteInfo($employeeId: HashedId!) {
    employeeDisplayTinyInfoByEmployeeId(id: $employeeId) {
      id
      firstName
      lastName
      avatarUrl
    }
    appraisalSeasonOptionByEmployeeId(employeeId: $employeeId) {
      id
      companyId
      country
      year
      fromDate
      toDate
    }
    nonParticipantsOptionsForEmployee(employeeId: $employeeId) {
      ...EmployeeWithBu
    }
    meetingInviteOptionsForEmployee(employeeId: $employeeId) {
      possible
      tagAssignmentIsInProgress
      isAppraisalEnabled
    }
  }
  ${employeeWithBuFragment}
`
